<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-btn class="green darken-2 white--text mr-4" @click="presincronizar()">
        <v-icon small class="mr-2">
          mdi-plus
        </v-icon>
        Sincronizar Hora
      </v-btn>

      <v-btn class="green darken-2 white--text" @click="presincronizarcata()">
        <v-icon small class="mr-2">
          mdi-plus
        </v-icon>
        Sincronizar Catalogo
      </v-btn>
    </template>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      loading: false,
    }),

    components: {},

    computed: {},

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    methods: {
      presincronizar() {
        let vue = this;
        let opt = {
          verification: 'si',
          verificationHelp: 'Escriba "[+:verification]" para Sincronizar Hora.',
          okText: 'Sincronizar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        var message = {
          title: 'Confirmar Sincronizacion Hora',
          body: '<br> <b>NOTA:</b> Esta accion es irreversible.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.finalizarItem(dialog);
          })
          .catch(function() {});
      },
      finalizarItem(dialog) {
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/sincronizarhora`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
          //data: {},
        };

        xaxios.request(config)
          .then(function(response) {
            window.console.log(response);
            dialog.close();
            vue.$root.$notify.show('Ok', { color: 'success' });
          })
          .catch(function(error) {
            window.console.log(error.response);
            dialog.close();
            vue.$root.$notify.show('Error', { color: 'red' });
          });
      },
      presincronizarcata() {
        let vue = this;
        let opt = {
          verification: 'si',
          verificationHelp: 'Escriba "[+:verification]" para Sincronizar Catalogo.',
          okText: 'Sincronizar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        var message = {
          title: 'Confirmar Sincronizacion catalogo',
          body: '<br> <b>NOTA:</b> Esta accion es irreversible.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.finalizarItemcata(dialog);
          })
          .catch(function() {});
      },
      finalizarItemcata(dialog) {
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/sincronizar/catalogo`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
          //data: {},
        };

        xaxios.request(config)
          .then(function(response) {
            window.console.log(response);
            dialog.close();
            vue.$root.$notify.show(response.data, { color: 'success' });
          })
          .catch(function(error) {
            window.console.log(error);
            dialog.close();
            vue.$root.$notify.show('Error', { color: 'red' });
          });
      },
    },
  };
</script>
